import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import USUARIO_BENEFICIOS from "../../../assets/img/USUARIO_BENEFICIOS.png";
import USUARIO_FINAL_BANNER_IMG from "../../../assets/img/USUARIO_FINAL_BANNER_IMG.png";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import USUARIO_FINAL_CARACTERISTICAS_IMG from "../../../assets/img/USUARIO_FINAL_CARACTERISTICAS_IMG.png";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const AlliesUsuarioFinal = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

	return (
		<>
			<ChangeableHeaderV2
				withTitle
				appearSecondNavbar={dropdownHeader} 
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_span_title}
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].usuario_yellow_title}
					boldText={content[language].usuario_bold_title}
				/>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{
						img: USUARIO_BENEFICIOS,
						alt: "USUARIO_BENEFICIOS",
					}}
					imgRadius
					boldText={content[language].usuario_bold_text}
					boldParagraph={content[language].usuario_bold_text_2}
					checkText={content[language].usuario_list}
				/>
			</div>

			<IndustryBannerBgSection route="my-tracker">
				<IndustryImageTextSection
					switchOrder
					inBanner
					image={{ img: USUARIO_FINAL_BANNER_IMG, alt: "Localizacion" }}
					yellowText={content[language].localizacion_yellow_title}
					boldText={content[language].localizacion_bold_text}
				/>
			</IndustryBannerBgSection>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{
						img: USUARIO_FINAL_CARACTERISTICAS_IMG,
						alt: "Hombre en Oficina",
					}}
					yellowText={content[language].prevencion_yellow_title}
					boldText={content[language].prevencion_bold_title}
					boldParagraph={content[language].prevencion_bold_text}
					checkText={content[language].prevencion_list}
					responsiveImgPosition="last"
				/>
			</div>
		</>
	);
};

export default AlliesUsuarioFinal;
